export default __webpack_public_path__ + "Apple_EN.79eed77a.svg";